import React, { useEffect } from 'react';
import { useCart } from '../../context/CartContext';
import './Cart.css';

const Cart = () => {
  const { 
    items, 
    isOpen, 
    removeFromCart, 
    updateQuantity, 
    closeCart, 
    getTotalItems,
    getTotalPrice
  } = useCart();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleQuantityChange = (productId, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart(productId);
    } else {
      updateQuantity(productId, newQuantity);
    }
  };

  const handleInquiry = () => {
    const itemsList = items.map(item => 
      `• ${item.name}${item.variant ? ` - ${item.variant}` : ''}
  Quantity: ${item.quantity}
  ${item.pieces ? `Set Size: ${item.pieces} pieces` : ''}
  Price: $${item.price} each
  Subtotal: $${item.price * item.quantity}`
    ).join('\n\n');
    
    const totalPrice = getTotalPrice();
    
    const message = `Hello Chahine Cutlery,

I am interested in the following items from your collection:

${itemsList}

*Total Estimated Value: $${totalPrice}*

Please provide more information about:
- Availability and delivery time
- Final pricing and any applicable discounts
- Shipping options
- Payment methods

I look forward to hearing from you.

Best regards`;
    
    const whatsappNumber = '96179403786';
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappLink, '_blank');
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="cart-overlay" onClick={closeCart}></div>
      <div className={`cart-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="cart-header">
          <h3>Selected Items</h3>
          <button 
            className="close-cart"
            onClick={closeCart}
            aria-label="Close cart"
          >
            ×
          </button>
        </div>

        <div className="cart-content">
          {items.length === 0 ? (
            <div className="empty-cart">
              <p>No items selected</p>
              <span>Browse our collections to add items for inquiry</span>
            </div>
          ) : (
            <>
              <div className="cart-items">
                {items.map((item) => (
                  <div key={item.id} className="cart-item">
                    <div className="item-image">
                      <img src={item.image} alt={item.name} />
                    </div>
                    
                    <div className="item-details">
                      <h4>{item.name}</h4>
                      {item.variant && (
                        <span className="item-variant">{item.variant}</span>
                      )}
                      {item.category && (
                        <span className="item-category">{item.category}</span>
                      )}
                      {item.pieces && (
                        <span className="item-pieces">{item.pieces} pieces</span>
                      )}
                      <div className="item-pricing">
                        <span className="item-price">${item.price} each</span>
                        <span className="item-subtotal">Subtotal: ${item.price * item.quantity}</span>
                      </div>
                      
                      <div className="quantity-controls">
                        <button 
                          onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                          aria-label="Decrease quantity"
                        >
                          −
                        </button>
                        <span className="quantity">{item.quantity}</span>
                        <button 
                          onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                          aria-label="Increase quantity"
                        >
                          +
                        </button>
                      </div>
                    </div>

                    <button 
                      className="remove-item"
                      onClick={() => removeFromCart(item.id)}
                      aria-label={`Remove ${item.name} from cart`}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>

              <div className="cart-footer">
                <div className="cart-summary">
                  <div className="summary-line">
                    <span>Total Items: {getTotalItems()}</span>
                  </div>
                  <div className="summary-line total-price">
                    <span>Estimated Total: ${getTotalPrice()}</span>
                  </div>
                </div>
                
                <button 
                  className="inquiry-btn whatsapp-btn"
                  onClick={handleInquiry}
                >
                  Send WhatsApp Inquiry
                </button>
                
                <p className="inquiry-note">
                  Click to send a detailed inquiry via WhatsApp. 
                  We'll provide final pricing and availability information.
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Cart;